<script>
  import {
    DynamicHeading,
    DynamicHeadingContext,
    GridContainer
  } from "@ObamaFoundation/of-design-system";
  import { cubicInOut } from "svelte/easing";
  import { fly } from "svelte/transition";

  export let hasNextMonth;

  export let areFiltersApplied;

  $: emptyMessage = areFiltersApplied
    ? "No events this month match your filters"
    : "No events remaining";
</script>

<GridContainer containerClass="pt-6">
  <div
    in:fly|global={{ duration: 500, ease: cubicInOut, y: 30, delay: 500 }}
    out:fly|global={{ duration: 500, ease: cubicInOut, y: -20, delay: 100 }}
  >
    <DynamicHeadingContext>
      <DynamicHeading suggestedHeadingLevel="2" class="heading-sm">
        <span class="text-black block">{emptyMessage}</span>
        {#if hasNextMonth}
          <span class="text-grey block"> See What's On for next month </span>
        {/if}
      </DynamicHeading>
    </DynamicHeadingContext>
  </div>
</GridContainer>
